import {validateField, clearFields, setFieldOptions, setCheckBoxValue} from './helpers/form'
import {
  SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS,
  VALIDATE_VACANCY_CRITERIA_VOICEACTOR_FIELD,
  CLEAR_VACANCY_CRITERIA_VOICEACTOR_FIELDS,
  SET_VACANCY_CRITERIA_CHECKBOX_VALUE
} from '../../../actions/pages/vacancy-page'

export function vacancyCriteriaVoiceActor (
  state = {
    valid: false,
    fields: [/*personal*/
      {
        name: 'SkillLevel',
        value: '',
        errors: [],
        rules: {
          title: 'Rating'
        },
        placeholder: 'Any level',
        options: []
      },
      {
        name: 'NativeLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Native language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AdditionalLanguage',
        value: '',
        errors: [],
        rules: {
          title: 'Additional language'
        },
        placeholder: 'Any language',
        options: []
      },
      {
        name: 'AgeFrom',
        value: '',
        errors: [],
        rules: {
          title: 'Age from'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'AgeTo',
        value: '',
        errors: [],
        rules: {
          title: 'Age to'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'City',
        value: '',
        errors: [],
        rules: {
          title: 'Preferred  city'
        },
        placeholder: 'Any city',
        options: []
      },
      {
        name: 'CountryofLiving',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Country of residence'
        },
        placeholder: 'Any country',
        options: []
      },
      {
        name: 'Region',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Region'
        },
        placeholder: 'Any region',
        options: []
      },
      {
        name: 'Ethnicity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Ethnicity'
        },
        placeholder: 'Any ethnicity',
        options: []
      },
      {
        name: 'Identity',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Identity'
        },
        placeholder: 'Any identity',
        options: []
      },
      {
          name: 'DoNotUse',
          value: false,
          type: 'checkbox',
          errors: [],
          rules: {
            title: 'Do not use'
          },
          options: []
      },
      {
        name: 'KnownTalent',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Known talent'
        }
      },
      {
        name: 'SkillVendorStatus',
        value: '',
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Inactive talent'
        },
        options: []
      },/*personal end*/
      {
        name: 'VoiceActorLiveActionMaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Male'
        }
      },
      {
        name: 'VoiceActorLiveActionFemaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Female'
        }
      },
      {
        name: 'VoiceActorAnimationMaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Male'
        }
      },
      {
        name: 'VoiceActorAnimationFemaleVoiceGender',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Female'
        }
      },
      {
        name: 'VoiceActorVoiceAge',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Voice age'
        },
        placeholder: 'Any age',
        options: []
      },
      {
        name: 'VoiceActorVoiceType',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Voice type'
        },
        placeholder: 'Any type',
        options: []
      },
      {
        name: 'VoiceActorLanguageAccent',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Language accent'
        },
        placeholder: 'Any accent',
        options: []
      },
      {
        name: 'VoiceActorTheatricalExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatrical'
        }
      },
      {
        name: 'VoiceActorTVExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'TV'
        }
      },
      {
        name: 'VoiceActorGamesExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Video Games'
        }
      },
      {
        name: 'VoiceActorPromoOrCommercialsExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Promo/Commercials'
        }
      },
      {
        name: 'VoiceActorLiveActionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'L/A'
        }
      },
      {
        name: 'VoiceActorAnimationExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Animation'
        }
      },
      {
        name: 'VoiceActorDubbingExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Dubbing'
        }
      },
      {
        name: 'VoiceActorAudiobooksExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audiobooks'
        }
      },
      {
        name: 'VoiceActorVoiceOverExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'V/O'
        }
      },
      {
        name: 'VoiceActorRadioExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Radio'
        }
      },
      {
        name: 'VoiceActorTheatreActorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Theatre Actor'
        }
      },
      {
        name: 'VoiceActorMovieActorExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Movie Actor'
        }
      },
      {
        name: 'VoiceActorAudioDescriptionExperience',
        value: false,
        type: 'checkbox',
        errors: [],
        rules: {
          title: 'Audio description'
        }
      },
      {
        name: 'VoiceActorStudios',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Studios',
          url: 'studios',
          profileType: 'VoiceActor'
        },
        placeholder: 'Any studio',
        options:''
      },
      {
        name: 'VoiceActorClients',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Clients',
          url: 'clients',
          profileType: 'VoiceActor'
        },
        placeholder: 'Any client'
      },
      {
        name: 'VoiceActorSchools',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Schools',
          url: 'schools',
          profileType: 'VoiceActor'
        },
        placeholder: 'Any school'
      },
      {
        name: 'VoiceActorUnion',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Union'
        },
        placeholder: 'Any union',
        options: []
      },
      {
        name: 'VoiceActorRemoteRecordingCapability',
        value: '',
        type: 'select',
        errors: [],
        rules: {
          title: 'Remote recording'
        },
        placeholder: 'Any status',
        options: []
      },
    ]
  },
  action
) {
  switch (action.type) {
    case SET_VACANCY_CRITERIA_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'SkillLevel', action.skillLevels);
      newState = setFieldOptions(newState, 'City', action.cities);
      newState = setFieldOptions(newState, 'NativeLanguage', action.nativeLanguages);
      newState = setFieldOptions(newState, 'AdditionalLanguage', action.languages);
      newState = setFieldOptions(newState, 'AgeFrom', action.ageFromList);
      newState = setFieldOptions(newState, 'CountryofLiving', action.country);
      newState = setFieldOptions(newState, 'Region', action.region);
      newState = setFieldOptions(newState, 'Ethnicity', action.ethnicity);
      newState = setFieldOptions(newState, 'Identity', action.identity);
      newState = setFieldOptions(newState, 'VoiceActorVoiceAge', action.voiceAgeRangeList);
      newState = setFieldOptions(newState, 'VoiceActorVoiceType', action.voiceTypeList);
      newState = setFieldOptions(newState, 'VoiceActorRemoteRecordingCapability', action.remoteRecordingListVoiceActor);
      newState = setFieldOptions(newState, 'VoiceActorStudios', action.voiceActorStudio);
      return setFieldOptions(newState, 'AgeTo', action.ageToList);
    }

    case SET_VACANCY_CRITERIA_CHECKBOX_VALUE: {
      var newState = setCheckBoxValue(state, 'KnownTalent', action.knownTalent);
      newState = setCheckBoxValue(newState, 'SkillVendorStatus', action.skillVendorStatus);
      return setCheckBoxValue(newState, 'DoNotUse', action.doNotUse);
    }

    case VALIDATE_VACANCY_CRITERIA_VOICEACTOR_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_VACANCY_CRITERIA_VOICEACTOR_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
